import { combineReducers, configureStore } from '@reduxjs/toolkit';

import authReducer from './slices/authSlice';
import documentDataReducer from './slices/documentDataSlice';
import documentNamesReducer from './slices/documentNamesSlice';
import documentBookNodeReducer from './slices/documentNodeSlice';
import editorRemountReducer from './slices/editorRemountSlice';
import siteReducer from './slices/siteSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  documentNode: documentBookNodeReducer,
  documentData: documentDataReducer,
  documentNames: documentNamesReducer,
  editorRemount: editorRemountReducer,
  site: siteReducer,
});

export const editorStore = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof editorStore.getState>;
export type AppDispatch = typeof editorStore.dispatch;
